export const EXSBINVOICETYPE_SHOW_RESET = 'EXSBINVOICETYPE_SHOW_RESET'
export const EXSBINVOICETYPE_SHOW_SET_ERROR = 'EXSBINVOICETYPE_SHOW_SET_ERROR'
export const EXSBINVOICETYPE_SHOW_SET_RETRIEVED = 'EXSBINVOICETYPE_SHOW_SET_RETRIEVED'
export const EXSBINVOICETYPE_SHOW_TOGGLE_LOADING = 'EXSBINVOICETYPE_SHOW_TOGGLE_LOADING'
